const wrapBareLatexBlocks = (value) => {
  const input = String(value || "");
  const segments = input.split("$$");
  const wrapped = segments.map((segment, index) => {
    if (index % 2 === 1) return segment;
    let updated = segment
      .replace(/\\begin\{align\*?\}/g, "\\\\begin{aligned}")
      .replace(/\\end\{align\*?\}/g, "\\\\end{aligned}");
    const envPattern =
      /\\begin\{(aligned|cases|array|matrix|pmatrix|bmatrix|vmatrix|gather\*?|gathered|equation\*?)\}[\s\S]*?\\end\{\1\}/g;
    updated = updated.replace(envPattern, (block) => `$$${block}$$`);
    return updated;
  });
  return wrapped.join("$$");
};

export const parseMathText = (text) => {
  if (!text) return [];

  const normalized = wrapBareLatexBlocks(text);
  const pattern =
    /(\$\$[\s\S]+?\$\$|\\\[[\s\S]+?\\\]|\\\([\s\S]+?\\\)|\$[^$]+\$)/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = pattern.exec(normalized)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        type: "text",
        value: normalized.slice(lastIndex, match.index),
      });
    }

    const token = match[0];
    let latex = token;
    let displayMode = false;

    if (token.startsWith("$$") && token.endsWith("$$")) {
      latex = token.slice(2, -2);
      displayMode = true;
    } else if (token.startsWith("\\[") && token.endsWith("\\]")) {
      latex = token.slice(2, -2);
      displayMode = true;
    } else if (token.startsWith("\\(") && token.endsWith("\\)")) {
      latex = token.slice(2, -2);
      displayMode = false;
    } else if (token.startsWith("$") && token.endsWith("$")) {
      latex = token.slice(1, -1);
      displayMode = false;
    }

    parts.push({
      type: "latex",
      value: latex,
      displayMode,
    });
    lastIndex = pattern.lastIndex;
  }

  if (lastIndex < normalized.length) {
    parts.push({
      type: "text",
      value: normalized.slice(lastIndex),
    });
  }

  return parts;
};
